// @flow

import { Component } from '../jsti/core';
import EventNames from '../constants/EventNames';
import Validator from './Validator';
import Scroll from './Scroll';
import { outerHeight } from '../classes/Helpers';

export default class FormValidator extends Component {
  #submitHandler: function;

  /**
   * Get the underlying validators
   */
  get validators(): Array<Validator> {
    return [...this.el.querySelectorAll('[data-component]')]
      .filter((element: HTMLElement) => element.dataset.component.includes('validator'))
      .map((element: HTMLElement) => window.store.app.getComponentByElement(element))
      .filter((component: ?Component) => component instanceof Validator);
  }

  /**
   * Initialize the component
   *
   * @param pEl
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);

    this.el.noValidate = true;

    this.#submitHandler = this.onSubmit.bind(this);
    this.addEventListener(EventNames.SUBMIT, this.#submitHandler);
  }

  /**
   * Executes when the form is submitted
   */
  async onSubmit(event?: Event): Promise<boolean> {
    event?.preventDefault();
    if (!(await this.validate())) return false;
    this.submit();
    return true;
  }

  /**
   * Submit the form
   */
  async submit(): void {
    if (!(this.el instanceof HTMLFormElement)) return;
    this.el.removeEventListener(EventNames.SUBMIT, this.#submitHandler);
    this.el.submit();
  }

  /**
   * validates all inputs in this.validators
   */
  async validate(): Promise<boolean> {
    let shouldSubmit: boolean = true;
    const failedValidators: Array<Validator> = [];

    for (const validator: Validator of this.validators) {
      const passes: boolean = await validator.validate();
      if (!passes) {
        shouldSubmit = false;
        failedValidators.push(validator);
      }
    }

    if (!shouldSubmit) {
      const offset = outerHeight(failedValidators[0].el.previousElementSibling ?? failedValidators[0].el);
      new Scroll().scroll(failedValidators[0].el.previousElementSibling, offset);
      return false;
    }

    return true;
  }
}
